import React, { Fragment } from "react";
import {
  Button,
  Input,
  Modal,
  Loader,
  GridContainer,
  GridColumn,
  GridRow
} from "arv-reactcomponents";
import { PdpComponents, StoreListModal } from "arv-extends";
import loadashGet from "lodash.get";

import { PDP_COMPONENTS } from "npmlinks-constants";

const { PincodeBlock } = PdpComponents;
const { StoresListView } = StoreListModal;
const { wrapper, getFinalComponent } = PincodeBlock;

class PincodeBlockWC extends wrapper {
  render() {
    const {
      pincode,
      fulfillmentCenters,
      isModalOpen,
      pincodeErrorMsg,
      modes
    } = this.state;
    const { className, inStock } = this.props;
    const storePickUpIncentiveValue = loadashGet(
      this.state,
      "storePickUpIncentiveData",
      0
    );
    return (
      <div className={`nw-pdp-pincode ${className}`}>
        <div className="nw-pincode-header">
          {PDP_COMPONENTS.PINCODE_BLOCK_TITLE}
        </div>
        <form className="nw-pincode-btns" onSubmit={this.pinCodeSubmit}>
          <GridContainer className="wc-pincode-container">
            <GridRow>
              <GridColumn className="nw-pincode-inputblock nwc-grid-col-xs-8">
                <Input
                  className="nw-pincode-input"
                  name="pincode"
                  type="tel"
                  placeholder={PDP_COMPONENTS.ENTER_PINCODE_TEXT}
                  ref={values => {
                    this.pincodeInput = values;
                  }}
                  value={pincode}
                  maxLength={6}
                  minLength={6}
                  onChange={this.validatePincode}
                  disabled={!inStock}
                  validateWithPattern={[
                    {
                      pattern: /^[0-9]*$/,
                      msg: "We need a valid 6-digit pincode. Try again, please."
                    }
                  ]}
                />
              </GridColumn>
              <GridColumn className="nwc-grid-col-xs-4 wc-pincode-btncol">
                <div className="nw-pincode-checkbtn">
                  <Button
                    type="submit"
                    className="nw-pincode-btn"
                    disabled={this.isPincodeValid || !inStock}
                  >
                    CHECK
                  </Button>
                  <Loader className={`nw-pincode-loader ${this.isLoader}`} />
                </div>
              </GridColumn>
            </GridRow>
          </GridContainer>
          <div className={`nw-pincode-error ${this.isPinCodeError}`}>
            {pincodeErrorMsg}
          </div>
        </form>
        {modes.map(mode => {
          const storeLength = fulfillmentCenters.length;
          const store =
            mode.order === 0 && storeLength > 0 ? (
              <Fragment>
                <Button
                  className={`nw-stores-length ${this.isStores}`}
                  onClick={this.openStoresModal}
                >
                  {storeLength} stores{" "}
                </Button>
                {storePickUpIncentiveValue ? (
                  <div className="nw-stores-storepickmsg">
                    (additional Rs. {`${storePickUpIncentiveValue}`} Off)
                  </div>
                ) : null}
                <Modal isOpen={isModalOpen} onClose={this.closeModal}>
                  <StoresListView.component
                    data={fulfillmentCenters}
                    pincode={pincode}
                  />
                </Modal>
              </Fragment>
            ) : (
              ""
            );
          return (
            <div className="nw-pincode-modes" key={mode.order}>
              <i className="icomoon-check nw-pincode-check" />
              <span className="nw-pincode-name">{mode.name}</span>
              {store}
            </div>
          );
        })}
      </div>
    );
  }
}

PdpComponents.PincodeBlock.component = getFinalComponent(PincodeBlockWC);
